import type { OtherLanguageCode } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Badge, Icon } from "@sagot/ui";

/**
 * "Other language: Cebuano" (LNG-003): the visitor wrote in Cebuano, Ilocano, Hiligaynon or Chinese. The assistant does not speak these and
 * never calls them Tagalog; the chip tells the agent, in words and an icon, so a person can take over in that language. Nothing for the
 * languages the assistant speaks.
 */
export function LanguageChip({ code }: { code: OtherLanguageCode | null | undefined }) {
  const { t } = useTranslation();
  if (!code) return null;
  const name = t(`engage.inbox.language.names.${code}`);
  return (
    <Badge tone="brand" title={t("engage.inbox.language.hint", { name })} data-testid="language-chip" data-language={code}>
      <Icon name="languages" className="size-3" />
      {t("engage.inbox.language.other", { name })}
    </Badge>
  );
}
